export const availableFilters = ({ filters }) => filters.availableFilters;
export const activeFilters = ({ filters }) => filters.activeFilters;
export const brands = ({ filters }) => ({
    allBrandFilters: filters.dropdownFilters.brand,
    availableBrandFilters: filters.availableFilters.brand
});
export const dropdownFilters = ({ filters }) => filters.dropdownFilters;
